import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LessonContentState = ReturnType<typeof getInitialState>;

const getInitialState = () => ({
    expandedProblemId: null as number | null,
    showCorrectAnswersForProblems: {} as Record<number, true>,
});

const slice = createSlice({
    name: 'LESSON_CONTENT',
    initialState: getInitialState(),
    reducers: {
        expandProblem: (state, action: PayloadAction<{ problemId: number | null }>) => {
            state.expandedProblemId = action.payload.problemId;
        },
        toggleShowCorrectAnswer: (state, action: PayloadAction<{ problemId: number }>) => {
            const problemId = action.payload.problemId;
            if (problemId in state.showCorrectAnswersForProblems) {
                delete state.showCorrectAnswersForProblems[problemId];
            } else {
                state.showCorrectAnswersForProblems[problemId] = true;
            }
        },
        close: (state) => {
            state.expandedProblemId = null;
        },
        reset: (state) => {
            Object.assign(state, getInitialState());
        },
    },
});

export const lessonContentActions = slice.actions;
export const lessonContentReducer = slice.reducer;
